import React from 'react'
import classNames from 'classnames'

import { ButtonContent } from '@/types'

interface DefaultButtonProps {
  type: 'button' | 'submit'
  handleClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  extendClass?: boolean
  className?: string
  content: ButtonContent
  disabled?: boolean
}

const DefaultButton: React.FC<DefaultButtonProps> = ({
  type = 'button',
  handleClick,
  extendClass = false,
  className,
  content,
  disabled = false,
  ...props
}) => {
  return (
    <button
      type={type}
      className={classNames(
        className && !extendClass ? className : 'text-primary-placeholder',
        className && extendClass && `text-primary-placeholder ${className}`,
        'flex gap-x-3 px-3.5 py-2.5 rounded-lg w-fit items-center focus:outline-none'
      )}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {content.icon && content.icon}
      {content.text}
    </button>
  )
}

export default DefaultButton
